// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1172":"a4b309867fd7ad8a","8448":"c71366e7cb570da2"}[chunkId] + ".css";
};